export const setDataInLocalStorage = async (key: string, data: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('err', e);
  }
};

export const getDataFromLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
  return null;
};

export const removeDataFromLocalStorage = async (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('err', e);
  }
};
